import { render } from "./Value5Section.vue?vue&type=template&id=48629366&scoped=true"
import script from "./Value5Section.vue?vue&type=script&lang=js"
export * from "./Value5Section.vue?vue&type=script&lang=js"

import "./Value5Section.vue?vue&type=style&index=0&id=48629366&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48629366"]])

export default __exports__